import { writer } from "@/backend/write/BackendWriter";
import type { RelativeCoordinate } from "@/model/coordinates";
import { useBoardStore } from "@/store/board";
import { useDraggingStore } from "@/store/dragging";

import { action, defineActions } from "./actions";
import { internalActions } from "./internalActions";

interface CardPosition {
  id: string;
  pos: RelativeCoordinate;
}

export const dragActions = defineActions("drag", {
  startCardDrag: action((positions: CardPosition[]) => {
    for (const pos of positions) {
      internalActions.cardToFront(pos.id);
      writer.startAlterCard(useBoardStore().currentBoard().id, pos.id);
      useDraggingStore().startCardDragging(pos.id, pos.pos);
    }
  }),
  dragCard: action((id: string, pos: RelativeCoordinate) => {
    internalActions.moveCard(useBoardStore().currentBoard().id, id, pos);
    useDraggingStore().dragCard(id, pos);
  }),
  endCardDrag: action((positions: CardPosition[]) => {
    for (const pos of positions) {
      internalActions.moveCard(useBoardStore().currentBoard().id, pos.id, pos.pos, true);
      useDraggingStore().endCardDragging(pos.id, pos.pos);
    }
  }),
});
